import snappy_process from "./images/icon-snappy-process.svg";
import price from "./images/icon-affordable-prices.svg";
import people from "./images/icon-people-first.svg";

export const content = [
  {
    id: 1,
    title: "Snappy Process",
    content:
      "Our application process can be    completed in minutes, not hours. Don’t get stuck filling in tedious forms.",
    img: snappy_process,
  },
  {
    id: 2,
    title: "Free Prices",
    content: `We don't want you worrying about high monthly costs. We have free service, but we still offer the best coverage possible`,
    img: price,
  },
  {
    id: 3,
    title: "People First",
    content:
      "Our plans aren’t full of conditions and clauses to prevent payouts. We make sure you’re covered when you need it.",
    img: people,
  },
];

export const recentEvent = [
  {
    id: 1,
    style: "border-cyan",
    title: "Artifical intelligence",
    description: "This is description",
    imgSrc: "images/icon-Supervisor.svg",
  },
  {
    id: 2,
    style: "border-red",
    title: "House warming",
    description: "This is description",
    imgSrc: "images/icon-team-builder.svg",
  },
  {
    id: 3,
    style: "border-orange",
    title: "Man ki baat",
    description: "This is description",
    imgSrc: "images/icon-karma.svg",
  },
  {
    id: 4,
    style: "border-blue",
    title: "Computer conference",
    description: "This is description",
    imgSrc: "images/icon-calculator.svg",
  },
];
